import { z } from "zod";
import { PLATFORMS, type Platform } from "./db.js";

export const JOB_TYPES = [
  "daily_profile",
  "post_24h",
  "post_7d",
  "manual_rescrape",
  "manual_video_initial",
] as const;
export type JobType = (typeof JOB_TYPES)[number];

export const JOB_STATUSES = [
  "pending",
  "dispatched",
  "running",
  "succeeded",
  "failed",
  "cancelled",
] as const;
export type JobStatus = (typeof JOB_STATUSES)[number];

export const ScheduledJobRowSchema = z.object({
  id: z.number().int(),
  job_type: z.enum(JOB_TYPES),
  project_id: z.number().int().nullable(),
  page_id: z.number().int().nullable(),
  video_id: z.number().int().nullable(),
  platform: z.enum(PLATFORMS).nullable(),
  due_at: z.number().int(),
  status: z.enum(JOB_STATUSES),
  attempts: z.number().int(),
  last_error: z.string().nullable(),
  payload: z.string().nullable(),
  created_at: z.number().int(),
  updated_at: z.number().int(),
  dispatched_at: z.number().int().nullable(),
  completed_at: z.number().int().nullable(),
});
export type ScheduledJobRow = z.infer<typeof ScheduledJobRowSchema>;

// Queue message: discriminated union by job_type. The dispatcher cron writes one of these
// onto the `scrape-jobs` queue per due scheduled_jobs row; the scraper consumer reads them.
// Profile-side payloads carry only `pageId` — the scraper looks up project/platform/url
// from `project_pages` to keep payload small and source-of-truth-correct.
export type QueueMessage =
  | { jobType: "daily_profile"; scheduledJobId: number; pageId: number }
  | { jobType: "manual_rescrape"; scheduledJobId: number; pageId: number }
  | { jobType: "post_24h"; scheduledJobId: number; videoId: number; platform: Platform; videoUrl: string }
  | { jobType: "post_7d"; scheduledJobId: number; videoId: number; platform: Platform; videoUrl: string }
  | { jobType: "manual_video_initial"; scheduledJobId: number; videoId: number; platform: Platform; videoUrl: string };

export const SECONDS_24H = 86_400;
export const SECONDS_7D = 7 * SECONDS_24H;
